<template>
  <span />
</template>

<script>
  export default {
    name: 'OneTrustCookieHelper',

    props: {
      stateCodes: { type: Array, required: true },
      countryCodes: { type: Array, required: true },
      siteHasOptimizely: { type: Boolean, required: true, default: false },
    },

    mounted() {
      this.main();
    },

    methods: {
      main() {
        setTimeout(() => {
          this.checkConsent();

          if (this.siteHasOptimizely) {
            this.checkOptimizely();
          }
        }, 1000);
      },

      getCookie(name) {
        let cookie = {};
        document.cookie.split(';').forEach(function(el) {
          let split = el.split('=');
          cookie[split[0].trim()] = split.slice(1).join('=');
        });
        return cookie[name];
      },

      setCookie(c_name, value, exdays) {
        let exdate = new Date();
        exdate.setDate(exdate.getDate() + exdays);
        let c_value =
          encodeURIComponent(value) +
          (exdays == null ? '' : '; expires=' + exdate.toUTCString() + '; path=/;');
        document.cookie = c_name + '=' + c_value;
      },

      checkConsent() {
        const ocCookie = this.getCookie('OptanonConsent');
        const oabcCookie = this.getCookie('OptanonAlertBoxClosed');
        const frCookie = this.getCookie('ForceReconsent');

        let canClearOptanonCookie = oabcCookie != null && ocCookie != null && frCookie == null;

        this.waitForOneTrust().then(() => {
          const currentState = window.OneTrust.getGeolocationData().state;
          const currentCountry = window.OneTrust.getGeolocationData().country;
          let inStateToCheck =
            this.countryCodes.includes(currentCountry) && this.stateCodes.includes(currentState);

          if (frCookie == null && inStateToCheck) {
            this.setCookie('ForceReconsent', `${currentCountry}-${currentState}`, 365);

            if (canClearOptanonCookie) {
              window.OneTrust.RejectAll();
              this.setCookie('OptanonConsent', '', -1);
              this.setCookie('OptanonAlertBoxClosed', '', -1);
              location.reload();
            }
          }
        });
      },

      waitForOneTrust() {
        let counter = 0;
        const maxChecks = 50;
        return new Promise((resolve, reject) => {
          const checkInterval = setInterval(() => {
            if (window.OneTrust) {
              clearInterval(checkInterval);
              resolve();
            } else if (counter >= maxChecks) {
              clearInterval(checkInterval);
              reject(new Error('Maximum number of checks reached'));
            }
            counter++;
          }, 100);
        });
      },

      functionalConsentGiven(onetrustActiveGroups) {
        return onetrustActiveGroups != null ? onetrustActiveGroups.includes('3') : false;
      },

      checkOptimizely() {
        let functionalConsentGiven = this.functionalConsentGiven(window.OnetrustActiveGroups);
        window.optimizely = window.optimizely || [];
        if (functionalConsentGiven) {
          window['optimizely'].push({
            type: 'sendEvents',
          });
          return;
        }
        window['optimizely'].push({
          type: 'holdEvents',
        });
      },
    },
  };
</script>
